/* Naiak - Barra de anúncio: no mobile mostra uma mensagem por vez (rotação automática + setas opcionais). */
if (!customElements.get('nk-announcement')) {
  class NkAnnouncement extends HTMLElement {
    connectedCallback() {
      this.items = Array.from(this.querySelectorAll('[data-nk-announcement-item]'));
      if (this.items.length < 2) return;

      this.index = 0;
      this.interval = parseInt(this.dataset.interval, 10) || 4000;
      this.mobileQuery = window.matchMedia('(max-width: 767px)');
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

      this.prevButton = this.querySelector('[data-nk-announcement-prev]');
      this.nextButton = this.querySelector('[data-nk-announcement-next]');
      this.onPrev = () => this.go(this.index - 1, true);
      this.onNext = () => this.go(this.index + 1, true);
      this.onPause = () => this.stop();
      this.onResume = () => this.start();
      this.onMediaChange = () => this.start();

      if (this.prevButton) this.prevButton.addEventListener('click', this.onPrev);
      if (this.nextButton) this.nextButton.addEventListener('click', this.onNext);
      this.addEventListener('mouseenter', this.onPause);
      this.addEventListener('mouseleave', this.onResume);
      this.addEventListener('focusin', this.onPause);
      this.addEventListener('focusout', this.onResume);
      this.mobileQuery.addEventListener('change', this.onMediaChange);

      // Editor de temas: ao selecionar um bloco, mostra a mensagem correspondente
      this.addEventListener('shopify:block:select', (event) => {
        const position = this.items.indexOf(event.target);
        if (position < 0) return;
        this.stop();
        this.go(position);
      });
      this.addEventListener('shopify:block:deselect', this.onResume);

      this.start();
    }

    disconnectedCallback() {
      this.stop();
      if (this.mobileQuery) this.mobileQuery.removeEventListener('change', this.onMediaChange);
    }

    start() {
      this.stop();
      if (!this.mobileQuery.matches || this.reducedMotion.matches) return;
      this.timer = window.setInterval(() => this.go(this.index + 1), this.interval);
    }

    stop() {
      if (this.timer) window.clearInterval(this.timer);
      this.timer = null;
    }

    go(nextIndex, restart = false) {
      const total = this.items.length;
      this.items[this.index].classList.remove('tp-nk-announcement__item--active');
      this.index = (nextIndex + total) % total;
      this.items[this.index].classList.add('tp-nk-announcement__item--active');
      if (restart) this.start();
    }
  }

  customElements.define('nk-announcement', NkAnnouncement);
}
